class ScfNewsTicker extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.scf-ticker__track');
    if (!this.track) return;

    this.speed = parseInt(this.dataset.speed || '30', 10);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.track.style.animation = 'none';
      return;
    }

    this.track.style.setProperty('--scf-ticker-duration', `${this.speed * 2}s`);

    this.addEventListener('mouseenter', () => this.setPaused(true));
    this.addEventListener('mouseleave', () => this.setPaused(false));
  }

  setPaused(paused) {
    if (this.track) {
      this.track.style.animationPlayState = paused ? 'paused' : 'running';
    }
  }
}

if (!customElements.get('scf-news-ticker')) {
  customElements.define('scf-news-ticker', ScfNewsTicker);
}
